import { morph } from '@theme/morph';

const PRODUCT_CONTENT_SELECTOR = [
  'product-card',
  'product-inventory',
  '[data-product-id]',
  '.nova-product-tile',
  '.nova-search-product-card',
  'form[action*="/cart/add"]',
].join(',');

const activeRequests = new WeakMap();

/** Refresh a Shopify section once so every product card and control in it uses current data. */
async function refreshProductSection(section) {
  if (!(section instanceof HTMLElement) || !section.id.startsWith('shopify-section-')) return;
  if (activeRequests.has(section)) return activeRequests.get(section);

  const sectionId = section.id.slice('shopify-section-'.length);
  const url = new URL(window.location.href);
  url.searchParams.set('section_id', sectionId);
  url.searchParams.set('_product_refresh', Date.now().toString());

  const request = fetch(url, { cache: 'no-store' })
    .then((response) => {
      if (!response.ok) throw new Error(`Section refresh failed (${response.status})`);
      return response.text();
    })
    .then((markup) => {
      if (!section.isConnected) return;

      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const newSection = parsed.getElementById(section.id) || parsed.body;
      morph(section, newSection, { childrenOnly: true });
    })
    .catch((error) => {
      console.warn('[product-section-refresh] Could not refresh section:', sectionId, error);
    })
    .finally(() => activeRequests.delete(section));

  activeRequests.set(section, request);
  return request;
}

function refreshProductSections() {
  const sections = new Set();
  document.querySelectorAll(`#MainContent .shopify-section :is(${PRODUCT_CONTENT_SELECTOR})`).forEach((productContent) => {
    const section = productContent.closest('.shopify-section');
    if (section) sections.add(section);
  });

  sections.forEach((section) => refreshProductSection(section));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshProductSections, { once: true });
} else {
  refreshProductSections();
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refreshProductSections();
});
